import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Col } from 'react-bootstrap';

// Components
import EditProfileForm from '../../components/EditProfileForm';
import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';

import cs from '../../components/commonStyle.css'
import s from './EditProfile.css';

const EditProfile = () => {

  return (
    <>
      <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
        <DashboardSideMenu isEditProfilePage />
      </Col>
      <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
        <EditProfileForm />
      </Col>
    </>
  );
}

EditProfile.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(cs, s)(EditProfile);